var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tasks-progress"},[_c('span',{staticClass:"progress-value"},[_vm._v(_vm._s(_vm.progress)+"%")]),_c('div',{staticClass:"progress-bar",style:({width: _vm.progress + '%'})})])
}
var staticRenderFns = []

export { render, staticRenderFns }